import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PRESUPUESTOS_LISTA, PRESUPUESTOS_NUEVO, PRESUPUESTOS_REPORTES } from 'constants/codigosTransacciones'

import * as PresupuestoNuevoPages from './presupuestos-nuevo'
import PresupuestoNuevoReportePages from './reportes'

import ListaPage from './lista'

export default function PresupuestosNuevoPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PRESUPUESTOS_NUEVO}/:id`} component={PresupuestoNuevoPages.NuevoPage} />
        <Route path={`/${PRESUPUESTOS_NUEVO}`} component={PresupuestoNuevoPages.NuevoPage} />
        <Route path={`/${PRESUPUESTOS_LISTA}`} component={ListaPage} />
        <Route path={`/${PRESUPUESTOS_REPORTES}`} component={PresupuestoNuevoReportePages} />
      </Switch>
    </Suspense>
  )
}
